import styled from 'styled-components';
import { SummaryDiscountDetailsStyled } from '../../SummaryDiscountDetailsStyled';
import { rem } from 'polished';

export const SummaryDiscountDetailsOV = styled(SummaryDiscountDetailsStyled)`
    .titleWrapper {
        .title {
            text-transform: uppercase;
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }

    .section {
        .description {
            font-size: ${rem(16)};
        }
        .discounts {
            .discount,
            .totalPrice {
                font-size: ${rem(16)};
            }
        }
    }
`;
